<template>
  <div>
    <div v-if="notFound">
      <h1>Oeps</h1>
      <p>
        De pagina werd niet gevonden. Ga terug naar onze
        <a href="/">homepagina</a>.
      </p>
      <p></p>
    </div>
    <div v-if="error">
      <h1>Oeps</h1>
      <p>Er ging iets mis, probeer het later even opnieuw.</p>
      <p></p>
    </div>
    <div v-if="!showPage && !notFound && !error">
      <h1>{{message}}</h1>
      <p style="margin-top:20px;">{{submessage}}</p>
      <p style="margin-top:20px;" v-if="message == 'Geen zoekresultaat'">Wat kun je doen?</p>
      <ul
        style="margin-top:10px; list-style-type:unset;margin-left: 20px;"
        v-if="message == 'Geen zoekresultaat'"
      >
        <li>Controleer de spelling van je zoekopdracht</li>
        <li>Probeer een andere zoekopdracht</li>
        <li>
          <a class="filter__more-label" href="/contactus">Neem contact met ons op</a>, sommige strips hebben wij exclusief in onze fysieke winkel.
        </li>
      </ul>
    </div>
    <div
      v-if="showPage && !notFound && !error"
      class="page category-page"
      style="display: flex; width: 100%;"
    >
      <div class="striep-product-row">
        <div class="product-page-header" style="width: 100%;">
          <h1 class="product-c">{{ pageTitle }}</h1>
          <div class="product-page-header-right">
            <span class="hide-mobile">{{ totalCount }} resultaten</span>
            <span class="hide-mobile">|</span>
            <label for="sort">Sorteer op:</label>
            <select @change="onChangeSort" v-model="selectedSort" id="sort" name="sort">
              <option v-for="sort in sorts" :key="sort.name" :value="sort.name">{{ sort.label }}</option>
            </select>
          </div>
          <div class="product-page-header-mobile-filter hide-desktop">
            <button class="btn-primary-alternative" @click="openMobileFilters()">Resultaten filteren</button>
          </div>
        </div>
        <div
          v-for="product in products"
          v-bind:class="category + ' striep-product-box' + ' ' + (product.isPromoPakket ? 'promopakket' : '')"
          :key="product.id"
        >
          <div class="square-box">
            <a class="square-content" :href="product.url">
              <template v-if="product.isPromoPakket">
              <img
                v-for="image in product.imageUrls"
                v-bind:class="'striep-product-box__image' + product.imageUrls.length"
                v-bind:src="image.imageUrl"
                :title="image.title"
                :alt="image.alternateText"
                :key="image.imageUrl"
              />
            </template>
            <img v-else v-bind:src="product.imageUrls[0].imageUrl" 
                :title="product.imageUrls[0].title"
                :alt="product.imageUrls[0].alternateText"
                :key="product.imageUrls[0].imageUrl" />
            </a>
          </div>

          <div class="striep-product-box-meta-data">
            <span class="striep-product-box-meta-data__title">
              <a v-bind:href="product.url">{{ product.title }}</a>
            </span>
            <div class="striep-product-box-meta-data__cover" v-if="product.cover">
              <span class>{{ product.cover }}</span>
            </div>
            <div class="striep-product-box-meta-data__price">
              <span v-if="product.oldPrice" class="old-price">&euro;&nbsp;{{product.oldPrice}}</span>
              <span class="current-price">&euro;&nbsp;{{ product.price }}</span>
            </div>
            <!-- <div class="striep-product-box-meta-data__url">
                            <a class="product-detail-url" :href="product.url">details<img style="margin-left: 4px;" src="\Themes\Striep2\Content\svg\arrow-right.svg" /></a>
            </div>-->
          </div>
        </div>
      </div>
    </div>
    <div class="category-pagination" v-if="showPage">
      <product-page-pagination-component
        :totalitemcount="totalCount"
        :visiblepagecount="9"
        :currentpage="page"
        :pagesize="pageSize"
        v-on:changepage="onPageChanged"
      />
    </div>
  </div>
</template>

<script>
import { hasClass, addClass, removeClass } from "@/helpers/functions";
export default {
  name: 'product-search-page-component',
  data: function () {
    return {
      availableSorts: [],
      facets: null,
      products: [],
      selectedFacets: [],
      sorts: [],
      page: Number,
      pageSize: Number,
      totalCount: Number,
      selectedSort: null,
      searchFacet: null,
      category: null,
      categories: [],
      query: "",
      showPage: false,
      showNotFound: false,
      message: "",
      submessage: "",
      notFound: false,
      error: false,
    };
  },
  computed: {
    pageTitle: function () {
      return `Zoekresultaten voor "${this.query}"`;
    },
  },
  mounted() {
    this.page = 1;
    this.pageSize = 24;
    let parsedUrl = this.parseUrl();
    if (this.query == null) {
      return;
    }
    let ajaxUrl = this.buildAjaxUrl(
      parsedUrl.query,
      parsedUrl.category,
      parsedUrl.page,
      parsedUrl.sort
    );
    this.fetchData(ajaxUrl);
  },
  methods: {
    closeMobileFilters: function () {
        document.querySelector('.master-wrapper-content').style.zIndex = "0"
      let element = document.querySelector(".category-filters");
      if (hasClass(element, "visible")) {
        removeClass(element, "visible");
        document.querySelector(".category-filters");
        let darkOverlay = document.querySelector(
          ".category-filters-dark-overlay"
        );
        removeClass(darkOverlay, "visible");
        let filterResultsButton = document.querySelector(
          ".view-filter-results"
        );
        removeClass(filterResultsButton, "visible");

        removeClass(document.querySelector("body"), "noscroll");
      }
    },
    openMobileFilters: function () {
      document.querySelector('.master-wrapper-content').style.zIndex = "1"
      let element = document.querySelector(".category-filters");
      if (!hasClass(element, "visible")) {
        addClass(element, "visible");
        document.querySelector(".category-filters");
        let darkOverlay = document.querySelector(
          ".category-filters-dark-overlay"
        );
        addClass(darkOverlay, "visible");
        let filterResultsButton = document.querySelector(
          ".view-filter-results"
        );
        addClass(filterResultsButton, "visible");

        addClass(document.querySelector("body"), "noscroll");
      }
    },
    fetchData(url) {
      if (!url) {
        url = this.buildAjaxUrl(
          this.query,
          this.category,
          this.page,
          this.selectedSort
        );
      }
      fetch(url)
        .then((result) => {
          if (!result.ok) {
            if (result.status == 404) {
              this.notFound = true;
              this.error = false;
            }
            if (result.status == 500) {
              this.error = true;
              this.notFound = false;
            }
            throw Error(result.status);
          }
          return result.json();
        })
        .then((json) => {
          this.notFound = false;
          this.error = false;
          this.facets = json.facetResult;
          this.products = json.products;
          this.sorts = json.availableSorts;
          this.totalCount = json.totalCount;
          this.pageSize = json.pageSize;
          this.selectedFacets = json.selectedFacets;
          this.category = json.selectedCategory;
          this.selectedSort = json.selectedSort;
          this.categories = json.categories;
          this.query = json.query;
          this.message = json.Message;
          this.submessage = json.Submessage;
          this.page = json.page;

          if (this.products.length > 0) {
            this.showPage = true;
          } else {
            this.showPage = false;
          }
        });
    },
    onCategorySelected: function (value) {
      this.category = value;
      this.page = 1;
      this.selectedSort = null;
      this.fetchData();
    },
    onChangeSort: function () {
      this.fetchData();
      this.updateUrl();
    },
    onPageChanged: function (page) {
      this.page = page;
      this.fetchData();
      this.updateUrl();
      let element = document.querySelector(".master-wrapper-content");
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },
    updateUrl: function () {
      let urlPath = `/search?q=${this.query}`;

      if (this.category) urlPath += `&categorie=${this.category}`;

      if (this.page) {
        urlPath += `&pagina=${this.page}`;
      } else {
        urlPath += `&pagina=1`;
      }

      if (this.selectedSort) urlPath += `&sorteren=${this.selectedSort}`;

      history.pushState(null, null, urlPath);
    },
    parseUrl() {
      let queryStringParams = window.location.search;
      let urlParams = new URLSearchParams(queryStringParams);

      let query = urlParams.get("q");
      let category = urlParams.get("categorie");
      let page = urlParams.get("pagina");
      let sort = urlParams.get("sorteren");

      let parsedUrl = {
        query: query,
        category: category,
        page: page,
        sort: sort,
      };

      return parsedUrl;
    },
    buildAjaxUrl(query, category, page, sort) {
      let url = `/publicsearch/full?query=${query}`;

      if (category) {
        url += "&category=" + category;
      }

      if (sort) {
        url += "&sort=" + sort;
      }

      if (page) {
        url += "&page=" + page;
      }

      return url;
    },
  },
};
</script>

<style>
.hello {
  background-color: #ffe;
}
</style>